export const ElementHelpTR={
ElHeID:{en:'ElHeID',cs:'',dataType:'number',format:'#0',required:true},
ElHePath:{en:'Path',cs:'',dataType:'string',required:true,maxLength:255},
ElHeName:{en:'Name',cs:'',dataType:'string',required:true,maxLength:255},
ElHeHelpHtml:{en:'Html',cs:'',dataType:'string'},
ElHeIsActive:{en:'Active',cs:'',dataType:'boolean',required:true},
ElHeTimeStamp:{en:'ElHeTimeStamp',cs:'ElHeTimeStamp',dataType:'number',format:'#0'},
ElHeFieldName:{en:'Field Name',cs:'',dataType:'string',maxLength:255}
}